import { Typography } from '@mui/material';
import { ColumnDef } from '@schooly/components/data-grid';
import { ReactNode } from 'react';

import { AttendanceDayCell } from './AttendanceCells';
import { AttendancePrimaryCell } from './AttendanceCells';
import {
  ATTENDANCE_CSS_CLASSES,
  ATTENDANCE_PRIMARY_COL_FIELD,
  AttendanceViewConfig,
  getAttendanceDayColWidth,
} from './constants';
import { AttendanceCellState, AttendanceGridColumn, AttendanceRow } from './types';

export type AttendanceDayHeaderRenderer = (column: AttendanceGridColumn) => ReactNode;

const createPrimaryColumn = <TRow extends AttendanceRow>(
  view: AttendanceViewConfig,
  primaryHeaderLabel: string,
): ColumnDef<TRow, AttendanceCellState, unknown> => ({
  field: ATTENDANCE_PRIMARY_COL_FIELD,
  headerName: '',
  sortable: false,
  resizable: false,
  disableColumnMenu: true,
  disableReorder: true,
  flex: 1,
  minWidth: view.primaryColWidth,
  cellClassName: ATTENDANCE_CSS_CLASSES.primaryCell,
  headerClassName: ATTENDANCE_CSS_CLASSES.primaryHeaderCell,
  renderHeader: () => (
    <Typography variant={view.primaryHeader.variant} pl={2.5} noWrap sx={view.primaryHeader.sx}>
      {primaryHeaderLabel}
    </Typography>
  ),
  renderCell: ({ row }) => <AttendancePrimaryCell row={row} />,
});

export const createAttendanceColumns = <TRow extends AttendanceRow>(
  columns: AttendanceGridColumn[],
  primaryHeaderLabel: string,
  view: AttendanceViewConfig,
  renderDayHeader: AttendanceDayHeaderRenderer,
): ColumnDef<TRow, AttendanceCellState, unknown>[] => [
  createPrimaryColumn<TRow>(view, primaryHeaderLabel),
  ...columns.map(
    (column): ColumnDef<TRow, AttendanceCellState, unknown> => ({
      sortable: false,
      resizable: false,
      disableColumnMenu: true,
      disableReorder: true,
      headerName: '',
      cellClassName: ATTENDANCE_CSS_CLASSES.dayCell,
      headerClassName: ATTENDANCE_CSS_CLASSES.dayHeaderCell,
      align: 'center' as const,
      field: column.key,
      width: getAttendanceDayColWidth(view),
      renderHeader: () => renderDayHeader(column),
      renderCell: ({ row }) => <AttendanceDayCell row={row} column={column} />,
    }),
  ),
];
